import { Dictionary } from '@common/types';
import { catalogDictionaryDataSelector } from '@modules/catalog/selectors/options/options';
import { createSelector } from 'reselect';
import { getCrossDockRefData } from '@modules/catalog/helpers/selectors/get-cross-dock-ref-data';

export const crossDockTableOptionsSelector = createSelector(catalogDictionaryDataSelector(Dictionary.Depot), getCrossDockRefData);
